'use client';
import { subscribeFn } from '@/service/common';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/navigation';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const { title, subtitle, list = [], send_title, send_desc, emarsysType } = data;
    const { locale } = getLocal();
    const prefixCls = 'image-background-card';

    const submitSubscribeHandle1 = ({ email }: any) => {
        submitSubscribe(email);
        return true;
    };
    const submitSubscribe = async (email: string) => {
        const cookieDataA = subscribeCookie({
            sector_name: 'bottom subscribe',
            entry_position: 0,
        });
        const res = await subscribeFn(email, emarsysType || 'WEB_FOOTER', locale, cookieDataA);
        if (res?.code === '0') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: 'Subscribe',
                status: 'success',
                tag: 'Agree',
                __btn_id1: `temp-${id}`,
                __btn_id2: 'form-submit',
                __btn_type: 'common',
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: 'Subscribe',
                status: 'fail',
                tag: 'Agree',
            });
        }
        return true;
    };
    return (
        <GloLayout className={`editor-image-background-card`} id={id} data={data}>
            <div className="eco-content-v2">
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <h2 className={`${prefixCls}-subtitle`}>{subtitle}</h2>
            </div>

            <div className={`${prefixCls}-list-out`}>
                <Swiper
                    className={`${prefixCls}-swiper`}
                    modules={list.length > 2 ? [Navigation] : []}
                    navigation={list.length > 2}
                    slidesPerView={'auto'}
                    spaceBetween={12}
                    initialSlide={0}
                >
                    {list.map((itemA: any, index: number) => (
                        <SwiperSlide className={`${prefixCls}-item`} key={index}>
                            <EcoLink href={itemA.href} className={`${prefixCls}-item-link`}>
                                <EcoImg pc={itemA.pc} h5={itemA.h5} className={`${prefixCls}-item-img`} />
                                <div className={`${prefixCls}-item-msg`}>
                                    <div className={`${prefixCls}-item-title`} style={{ color: itemA?.titleColor }}>
                                        {itemA.title}
                                    </div>
                                    <div className={`${prefixCls}-item-desc`}>{itemA.desc}</div>
                                </div>
                            </EcoLink>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </GloLayout>
    );
}
